(function () {
  if (window.colourLandColourHelpReady) return;
  window.colourLandColourHelpReady = true;
  var selector = 'a[href], button, input, select, textarea, summary, [tabindex]';
  var controllers = new Map();

  function initialise(modal) {
    if (modal.dataset.colourHelpReady) return;
    modal.dataset.colourHelpReady = 'true';
    modal.dataset.colourHelpEnhanced = 'true';
    modal.setAttribute('aria-hidden', 'true');
    var panel = modal.querySelector('[data-colour-help-panel]');
    var isOpen = false;
    var opener = null;
    var previousUrl = null;
    var backgroundStates = [];
    var savedOverflow = null;
    var listeners = [];

    function listen(target, type, handler) {
      target.addEventListener(type, handler);
      listeners.push({ target: target, type: type, handler: handler });
    }

    function matchesHash() {
      try { return decodeURIComponent(location.hash.slice(1)) === modal.id; }
      catch (error) { return false; }
    }

    function canFocus(element) {
      if (!element || !element.isConnected || element.matches(':disabled') || element.closest('[inert]')) return false;
      for (var node = element; node; node = node.parentElement) {
        var style = getComputedStyle(node);
        if (node.hidden || style.display === 'none' || style.visibility === 'hidden') return false;
        if (node.tagName === 'DETAILS' && !node.open) {
          var summary = Array.from(node.children).find(function (child) { return child.tagName === 'SUMMARY'; });
          if (!summary || !summary.contains(element)) return false;
        }
      }
      return element.getClientRects().length > 0;
    }

    function tabStops() {
      return Array.from(modal.querySelectorAll(selector)).filter(function (element) {
        return element.tabIndex >= 0 && canFocus(element);
      });
    }

    function focusStart() {
      (tabStops()[0] || modal).focus({ preventScroll: true });
    }

    function isolateBackground() {
      var style = document.body.style;
      savedOverflow = Array.from(style).filter(function (property) {
        return ['overflow', 'overflow-x', 'overflow-y'].includes(property);
      }).map(function (property) {
        return { property: property, value: style.getPropertyValue(property), priority: style.getPropertyPriority(property) };
      });
      style.setProperty('overflow', 'hidden');
      var branch = modal;
      while (branch.parentElement) {
        var parent = branch.parentElement;
        Array.from(parent.children).forEach(function (sibling) {
          if (sibling === branch) return;
          backgroundStates.push({ element: sibling, inert: sibling.getAttribute('inert') });
          sibling.setAttribute('inert', '');
        });
        if (parent === document.body) break;
        branch = parent;
      }
    }

    function restoreBackground() {
      backgroundStates.splice(0).forEach(function (state) {
        if (state.inert === null) state.element.removeAttribute('inert');
        else state.element.setAttribute('inert', state.inert);
      });
      var style = document.body.style;
      ['overflow', 'overflow-x', 'overflow-y'].forEach(function (property) { style.removeProperty(property); });
      if (savedOverflow) savedOverflow.forEach(function (state) { style.setProperty(state.property, state.value, state.priority); });
      savedOverflow = null;
    }

    function isTrigger(link) {
      if (!link || !link.hasAttribute('href')) return false;
      var url = new URL(link.href, location.href);
      try { return url.origin === location.origin && url.pathname === location.pathname && url.search === location.search && decodeURIComponent(url.hash.slice(1)) === modal.id; }
      catch (error) { return false; }
    }

    function open(trigger, updateUrl) {
      if (isOpen || modal.closest('[inert]') || !modal.isConnected) return;
      opener = trigger;
      previousUrl = matchesHash() ? location.href.slice(0, location.href.indexOf('#')) : location.href;
      if (updateUrl) {
        var url = new URL(location.href);
        url.hash = modal.id;
        history.replaceState(history.state, '', url.href);
      }
      isOpen = true;
      modal.dataset.colourHelpOpen = 'true';
      modal.setAttribute('aria-hidden', 'false');
      if (panel) panel.scrollTop = 0;
      focusStart();
      isolateBackground();
    }

    function close(restoreUrl, returnFocus) {
      if (!isOpen) return;
      isOpen = false;
      modal.removeAttribute('data-colour-help-open');
      modal.setAttribute('aria-hidden', 'true');
      restoreBackground();
      if (restoreUrl && matchesHash()) history.replaceState(history.state, '', previousUrl);
      var target = canFocus(opener) ? opener : Array.from(document.querySelectorAll('a[href]')).find(function (link) { return isTrigger(link) && canFocus(link); });
      opener = null;
      if (returnFocus !== false && target) target.focus({ preventScroll: true });
    }

    listen(document, 'click', function (event) {
      var link = event.target.closest('a[href]');
      if (!isTrigger(link) || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || link.target === '_blank') return;
      if (!canFocus(link)) return;
      event.preventDefault();
      open(link, true);
    });
    listen(modal, 'click', function (event) {
      if (event.target === modal || event.target.closest('[data-colour-help-close]')) {
        event.preventDefault();
        close(true);
      }
    });
    listen(document, 'keydown', function (event) {
      if (!isOpen) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        close(true);
      } else if (event.key === 'Tab') {
        var stops = tabStops();
        var first = stops[0] || modal;
        var last = stops[stops.length - 1] || modal;
        var active = document.activeElement;
        if (!stops.length || !stops.includes(active) || event.shiftKey && active === first || !event.shiftKey && active === last) {
          event.preventDefault();
          (event.shiftKey ? last : first).focus({ preventScroll: true });
        }
      }
    });
    listen(document, 'focusin', function (event) {
      if (isOpen && !modal.contains(event.target)) focusStart();
    });
    function syncHash() {
      if (matchesHash()) open(null, false);
      else close(false, false);
    }
    listen(window, 'hashchange', syncHash);
    listen(window, 'popstate', syncHash);
    controllers.set(modal, function () {
      close(false, false);
      listeners.splice(0).forEach(function (listener) { listener.target.removeEventListener(listener.type, listener.handler); });
      modal.removeAttribute('data-colour-help-ready');
      modal.removeAttribute('data-colour-help-enhanced');
      modal.removeAttribute('aria-hidden');
      controllers.delete(modal);
    });
    syncHash();
  }

  function initialiseAll() {
    document.querySelectorAll('[data-colour-help-dialog]').forEach(initialise);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseAll);
  else initialiseAll();
  document.addEventListener('shopify:section:load', initialiseAll);
  document.addEventListener('shopify:section:unload', function (event) {
    controllers.forEach(function (dispose, modal) {
      if (event.target === modal || event.target.contains(modal)) dispose();
    });
  });
  var observer = new MutationObserver(function () {
    controllers.forEach(function (dispose, modal) { if (!modal.isConnected) dispose(); });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
